import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue } = colors;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  cursor: pointer;
  color: ${darkBlue};
  text-decoration: underline;
  font-size: 14px;
  margin-bottom: 0;

  &:hover {
    transition: opacity ease-in-out 300ms;
    opacity: 0.6;
  }

  svg {
    display: inline-block;
    margin-right: 4px;

    path {
      fill: ${darkBlue};
    }
  }
`;

export const HasFiles = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const FileName = styled.p`
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  margin-bottom: 0;
  color: ${darkBlue};
`;

export const ResetFiles = styled.button`
  margin-left: 12px;
  outline: 0;
  border: 0;
  background-color: transparent;
  font-weight: 700;
  color: ${darkBlue};
  line-height: 100%;
  font-size: 16px;

  &:hover {
    transition: opacity ease-in-out 300ms;
    opacity: 0.6;
  }
`;

export const FileInput = styled.input.attrs({
  type: 'file',
})`
  display: none;
`;
